<script setup lang="ts">
    import { type Row } from '@tanstack/table-core';
    import { Checkbox } from '@/components/ui/checkbox';

    const props = defineProps<{
        row: Row<unknown>;
    }>();
</script>

<template>
    <Checkbox
        :model-value="row.getIsSelected()"
        :disabled="!row.getCanSelect()"
        @update:model-value="(value) => row.toggleSelected(!!value)"
        aria-label="Select row"
    />
</template>
